import { useTranslation } from 'react-i18next';
import {
  FormContainerWithHeader,
  PaperLayout,
} from '../../../../../presentation';
import './policy.overview.documents-list.scss';

export const DocumentListFormSection = () => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'entities.policy.detail.content.sections.overview.documentList',
        'Document list'
      )}
    >
      <PaperLayout className="policy-overview-documents-list-layout">
        <p>To be Implemented</p>
      </PaperLayout>
    </FormContainerWithHeader>
  );
};
